import React from 'react'

import { Box, Heading2, Text } from '@gousto-internal/citrus-react'
import type { CategoryBrandingContentBlock } from '@library/api-menu-experience'

type CategoryBrandingHeaderProps = {
  contentBlock: CategoryBrandingContentBlock
}

export const CategoryBrandingHeader = ({ contentBlock }: CategoryBrandingHeaderProps) => (
  <Box
    data-testid="category-branding-hero"
    paddingV={[5, 6, 6]}
    paddingBottom={[1, 2, 2]}
    paddingH={[3, 3, 0]}
    style={{ backgroundColor: 'transparent' }}
  >
    <Box maxWidth={['100%', '100%', '52rem']}>
      <Heading2 style={{ color: contentBlock.textColor }}>{contentBlock.title}</Heading2>
      <Box paddingBottom={3} style={{ marginTop: '0.5rem' }}>
        <Text style={{ color: contentBlock.textColor }}>{contentBlock.description}</Text>
      </Box>
    </Box>
  </Box>
)
